/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_Save_TextInputs */

const en_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a preset name:`)
};

const fr_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez saisir un nom de prereglage :`)
};

const de_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie einen voreingestellten Namen ein:`)
};

const it_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome predefinito:`)
};

const ru_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите предустановленное имя:`)
};

const es_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduzca un nombre preestablecido:`)
};

const zh_cn2_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入预设名称：`)
};

const ja_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセット名を入力してください:`)
};

const hi_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक पूर्व निर्धारित नाम दर्ज करें:`)
};

const pt_pt2_image_export_style_preset_save_text = /** @type {(inputs: Image_Export_Style_Preset_Save_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira um nome predefinido:`)
};

/**
* | output |
* | --- |
* | "Please enter a preset name:" |
*
* @param {Image_Export_Style_Preset_Save_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_save_text = /** @type {((inputs?: Image_Export_Style_Preset_Save_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Save_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_save_text(inputs)
	if (locale === "de") return de_image_export_style_preset_save_text(inputs)
	if (locale === "it") return it_image_export_style_preset_save_text(inputs)
	if (locale === "ru") return ru_image_export_style_preset_save_text(inputs)
	if (locale === "es") return es_image_export_style_preset_save_text(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_save_text(inputs)
	if (locale === "ja") return ja_image_export_style_preset_save_text(inputs)
	if (locale === "hi") return hi_image_export_style_preset_save_text(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_save_text(inputs)
	return en_image_export_style_preset_save_text(inputs)
});